// extracted by mini-css-extract-plugin
export default {"dropdown":"ExpandableDropdown_dropdown__5tZjU"};